import { render, staticRenderFns } from "./AnalisePontoDuplicado.vue?vue&type=template&id=401d68b6&"
import script from "./AnalisePontoDuplicado.vue?vue&type=script&lang=js&"
export * from "./AnalisePontoDuplicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports